import { Edit } from '@rsuite/icons';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Input,
  Panel,
  Avatar,
  Uploader,
  IconButton,
  Stack,
  Image,
  Text,
  PanelGroup,
  List
} from 'rsuite';
import './ProfileEdit.less';
import {
  MdOutlineGrade,
  MdOutlineHomeWork,
  MdOutlinePassword,
  MdOutlineSick,
  MdSick
} from 'react-icons/md';
import { RiHomeOfficeFill, RiTeamLine, RiUserShared2Line } from 'react-icons/ri';
import { BiBriefcase } from 'react-icons/bi';
import { LuBuilding2 } from 'react-icons/lu';
import { FaRegBuilding, FaRegUser, FaUmbrellaBeach } from 'react-icons/fa';
import { useAppDispatch, useAppSelector } from '@/config/hooks';
import { getUserBalance, getUserByID } from '@/services/user.service';
import { getCurrentUser } from '@/services/auth.service';
import { format } from 'date-fns';
import { getSettings } from '@/services/setting.service';
import DrawerPassword from './DrawerPassword';
import { useTranslation } from 'react-i18next';

const Index = () => {
  const dispatch = useAppDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [balances, setBalances] = useState({});
  //   const [profile, setProfile] = useState({
  //     firstname: 'Rawen ',
  //     lastname: 'Mersani',
  //     Email: 'rawen.mersani@example.com',
  //     phone: '(216) 90123456',
  //     photo: 'scaled_image_picker2572779663588007782.jpg'
  //   });

  const [passwordUpdate, setPasswordUpdate] = useState(false);
  const user = getCurrentUser();
  const profile = useAppSelector((state: any) => state.users.item);
  const features = useAppSelector(state => state.feature.data);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getUserByID(user.id));
    // dispatch(getSettings('Homepage'));
    const fetchBalances = async () => {
      const balances = await getUserBalance(user.id);
      setBalances({
        sickBalance: balances?.sickBalance,
        LeaveBalance: balances?.LeaveBalance,
        extraBalance: balances.extraBalance
      });
    };
    fetchBalances();
  }, []);

  return (
    <div>
      <Panel style={{ marginTop: '30px' }} header={t('Edit Profile')}>
        <div style={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
          <Panel className="profile-container">
            {/* <Panel>
              <Avatar size="lg" circle src={profile.avatar} alt="Profile Picture" />
              <Uploader action="//jsonplaceholder.typicode.com/posts/" className="upload-button">
                <Button appearance="ghost">Upload new photo</Button>
              </Uploader>
              <p className="upload-hint">
                <strong>Rawen Mersani</strong>
              </p>
            </Panel> */}
            <Stack direction="column" justifyContent="center" alignItems="center">
              {profile.photo ? (
                <Avatar size="xxl" circle src={process.env.REACT_APP_IMAGE_URL + profile.photo} />
              ) : (
                // <Image
                //   circle
                //   src={process.env.REACT_APP_IMAGE_URL + profile.photo}
                //   alt="User Avatar"
                //   width={160}
                //   //   style={{ width: 100, height: 100 }}
                // />
                <Avatar circle size="xxl" />
              )}
              <h4 style={{ marginTop: 10, fontWeight: 'bolder' }}>
                {profile.firstname} {profile.lastname}
              </h4>
              <Text muted>{profile.Email}</Text>
              {/* <p className="error-page-subtitle text-muted ">
                <MdOutlineGrade /> {profile.grade?.grade_name}
              </p>
              <p className="error-page-subtitle text-muted ">
                <RiTeamLine /> {profile.serviceLine?.serviceLine}
              </p> */}
              <div className="grade-department-card">
                <div className="grade">
                  <MdOutlineGrade className="icon" />
                  <span className="label">{profile.grade?.grade_name}</span>
                </div>

                <div className="separator"></div>

                <div className="department">
                  <RiTeamLine className="icon" />
                  <span className="label">{profile.serviceLine?.serviceLine}</span>
                </div>
              </div>
              <div style={{ marginTop: 20, display: 'flex', gap: 5 }}>
                <Button
                  style={{ display: 'flex', gap: 5 }}
                  appearance="ghost"
                  onClick={() => setPasswordUpdate(true)}
                >
                  <MdOutlinePassword /> {t('Update my password')}
                </Button>
              </div>
            </Stack>
          </Panel>
          {/* <div className="info-panel">
            <Stack justifyContent="space-between" style={{ marginBottom: 20 }}>
              <Panel className="card-balance">
                <h3>5</h3>
                <Stack>
                  <h5>Sick Balance</h5>
                  <MdOutlineSick />
                </Stack>
              </Panel>
              <Panel>
                <h3>5</h3>
                <Stack>
                  <h5>Sick Balance</h5>
                  <MdOutlineSick />
                </Stack>
              </Panel>
              <Panel>
                <h3>5</h3>
                <Stack>
                  <h5>Sick Balance</h5>
                  <MdOutlineSick />
                </Stack>
              </Panel>
            </Stack> */}
          <Panel className="info-container">
            {/* <Stack spacing={70} wrap>
                <div>
                  <strong>Full Name</strong>

                  <Text muted>
                    {profile.firstname} {profile.lastname}
                  </Text>
                </div>
                <div>
                  <strong>Registration Number</strong>

                  <Text muted>{profile.registrationNumber}</Text>
                </div>
                <div>
                  <strong>Phone</strong>

                  <Text muted>{profile.telephone}</Text>
                </div>
                <div>
                  <strong>Manager</strong>

                  <Text muted>
                    {profile.manager?.firstname} {profile.manager?.lastname}
                  </Text>
                </div>
                <div>
                  <strong>Second Manager</strong>

                  <Text muted>
                    {profile.secondValidator?.firstname} {profile.secondValidator?.lastname}
                  </Text>
                </div>
                <div>
                  <strong>Hire date</strong>

                  <Text muted>{profile.hire_date}</Text>
                </div>
              </Stack>
              <Stack spacing={70} wrap style={{ marginTop: 20 }}>
                <div>
                  <strong>WFH Profile</strong>

                  <Text muted>{profile.wfhProfile?.name}</Text>
                </div>
                <div>
                  <strong>Seniority balance</strong>

                  <Text muted>{profile.registrationNumber}</Text>
                </div>
                <div>
                  <strong>Part Time</strong>

                  <Text muted>{profile.partTime}</Text>
                </div>
              </Stack>
              <Stack spacing={70} wrap style={{ marginTop: 20 }}>
                <div>
                  <strong>Access Profile</strong>

                  <Text muted>{profile.Group?.name}</Text>
                </div>
                <div>
                  <strong>Dedicated Desk</strong>

                  <Text muted>{profile.desk?.name}</Text>
                </div>
                <div>
                  <strong>Dedicated Parking Spot</strong>

                  <Text muted>{profile.spot?.name}</Text>
                </div>
              </Stack> */}
            <PanelGroup style={{ flex: 1, overflowY: 'auto' }}>
              <Panel
                header={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      color: 'var(--rs-blue-800)'
                    }}
                  >
                    <FaRegUser style={{ fontSize: '16px' }} />
                    <span>{t('Personal Information')}</span>
                  </div>
                }
              >
                <Stack justifyContent="space-between" wrap>
                  <div>
                    <strong>{t('Full Name')}</strong>

                    <Text muted>
                      {profile.firstname} {profile.lastname}
                    </Text>
                  </div>
                  <div>
                    <strong>{t('Registration Number')}</strong>

                    <Text muted>{profile.registrationNumber}</Text>
                  </div>
                  <div>
                    <strong>{t('Phone')}</strong>

                    <Text muted>{profile.telephone}</Text>
                  </div>
                  <div>
                    <strong>{t('Manager')}</strong>

                    <Text muted>
                      {profile.manager?.firstname} {profile.manager?.lastname}
                    </Text>
                  </div>
                  <div>
                    <strong>{t('Second Manager')}</strong>

                    <Text muted>
                      {profile.secondValidator?.firstname} {profile.secondValidator?.lastname}
                    </Text>
                  </div>
                  <div>
                    <strong>{t('Hire date')}</strong>

                    <Text muted>
                      {profile.hire_date ? format(new Date(profile.hire_date), 'dd-MM-yyyy') : ''}
                    </Text>
                  </div>
                </Stack>
              </Panel>
              {features?.find(item => item.name?.toLowerCase() == 'wfh') && (
                <Panel
                  header={
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: 'var(--rs-blue-800)'
                      }}
                    >
                      <MdOutlineHomeWork style={{ fontSize: '16px' }} />
                      <span>{t('Remote Working')}</span>
                    </div>
                  }
                >
                  <Stack spacing={70} wrap>
                    <div>
                      <strong>{t('Home office Profile')}</strong>

                      <Text muted>{profile.wfhProfile?.name}</Text>
                    </div>
                    <div>
                      <strong>{t('Authorized Home Office Days')}</strong>

                      <Text muted>{profile.wfhProfile?.authorizedWfhDays?.join(', ')}</Text>
                    </div>
                    <div>
                      <strong>{t('Part Time')}</strong>

                      <Text muted>{profile.partTime || ' '}</Text>
                    </div>
                    {features?.find(item => item.name?.toLowerCase() == 'leave') && (
                      <>
                        {
                          <div>
                            <strong>{t('Authorized Remote Days Per Week')}</strong>

                            <Text muted>
                              {balances?.extraBalance
                                ? profile?.wfhProfile?.daysPerWeekWithBalance
                                : profile?.wfhProfile?.daysPerWeekWithoutBalance}
                            </Text>
                          </div>
                        }
                      </>
                    )}
                  </Stack>
                </Panel>
              )}
              {features?.find(item => item.name?.toLowerCase() == 'on site') && (
                <Panel
                  header={
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: 'var(--rs-blue-800)'
                      }}
                    >
                      <FaRegBuilding style={{ fontSize: '16px' }} />
                      <span>{t('Flex office')}</span>
                    </div>
                  }
                >
                  <Stack spacing={70} wrap>
                    <div>
                      <strong>{t('Access Profile')}</strong>

                      <Text muted>{profile.Group?.name}</Text>
                    </div>
                    <div>
                      <strong>{t('Dedicated Desk')}</strong>

                      <Text muted>{profile.desk?.name}</Text>
                    </div>
                    <div>
                      <strong>{t('Dedicated Parking Spot')}</strong>

                      <Text muted>{profile.spot?.name}</Text>
                    </div>
                  </Stack>
                </Panel>
              )}
            </PanelGroup>
          </Panel>
          <div className="cards-balance">
            {features?.find(item => item.name?.toLowerCase() == 'leave') && (
              <div className="card-balance" style={{ backgroundColor: '#edfbff' }}>
                <div className="balance-header" style={{ color: '#42a0f5' }}>
                  <h3>{balances?.LeaveBalance}</h3>
                  <FaUmbrellaBeach size={30} />
                </div>
                <Text muted style={{ width: 50 }}>
                  {t('Leave Balance')}
                </Text>
              </div>
            )}

            {features?.find(item => item.name?.toLowerCase() == 'leave') && (
              <div className="card-balance" style={{ backgroundColor: '#f0eaff' }}>
                <div className="balance-header" style={{ color: '#8a5dee' }}>
                  <h3>{balances?.sickBalance}</h3>

                  <MdSick size={30} />
                </div>
                <Text muted style={{ width: 50 }}>
                  {t('Sick Balance')}
                </Text>
              </div>
            )}
            {features?.find(item => item.name?.toLowerCase() == 'wfh') && (
              <div className="card-balance" style={{ backgroundColor: '#ffe8e5' }}>
                <div className="balance-header" style={{ color: '#f36c27' }}>
                  <h3>{balances?.extraBalance}</h3>
                  <RiHomeOfficeFill size={30} />
                </div>
                <Text muted style={{ width: 50 }}>
                  {t('Extra Balance')}
                </Text>
              </div>
            )}

            {features?.find(item => item.name?.toLowerCase() == 'wfh') &&
              !features?.find(item => item.name?.toLowerCase() == 'leave') && (
                <div className="card-balance" style={{ backgroundColor: '#edfbff' }}>
                  <div className="balance-header" style={{ color: '#42a0f5' }}>
                    <h3>
                      {balances?.extraBalance
                        ? profile?.wfhProfile?.daysPerWeekWithBalance
                        : profile?.wfhProfile?.daysPerWeekWithoutBalance}
                    </h3>
                    <RiHomeOfficeFill size={30} />
                  </div>
                  <Text muted style={{ width: 50 }}>
                    {t('Remote Days/Week')}
                  </Text>
                </div>
              )}
          </div>
          {/* </div> */}
        </div>
      </Panel>
      {passwordUpdate && (
        <DrawerPassword open={passwordUpdate} setOpen={() => setPasswordUpdate(false)} />
      )}
    </div>
  );
};

export default Index;
